"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageContentContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _corePlugin = babelHelpers.interopRequireDefault(require("core-plugin"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _SidebarNavigation = babelHelpers.interopRequireDefault(require("components/SidebarNavigation"));

var _SiteNavigation = babelHelpers.interopRequireDefault(require("components/SiteNavigation"));

var _FooterNavigation = babelHelpers.interopRequireDefault(require("components/FooterNavigation"));

var _setup = require("sidebar/setup");

var _userProfile = require("user-profile");

var _excluded = ["content", "scripts", "type"];

var _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}


var PageContentContainer = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(PageContentContainer, _Component);

  var _super = _createSuper(PageContentContainer);

  function PageContentContainer() {
    var _this;

    babelHelpers.classCallCheck(this, PageContentContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      refreshCounter: 0,
      currentRefresh: -1
    };
    return _this;
  }

  babelHelpers.createClass(PageContentContainer, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(newProps) {
      if (!(newProps.content == this.props.content && JSON.stringify(newProps.scripts) == JSON.stringify(this.props.scripts))) {
        var nodes = _reactDom.default.findDOMNode(this).querySelectorAll('[data-reactroot]');

        nodes = [].slice.call(nodes);

        while (nodes.length) {
          nodes = nodes.filter(function (node) {
            if (node.querySelector(':scope [data-reactroot]')) return true;

            _reactDom.default.unmountComponentAtNode(node.parentNode);

            return false;
          });
        }

        this.setState(function (_ref) {
          var refreshCounter = _ref.refreshCounter;
          return {
            refreshCounter: refreshCounter + 1,
            pendingScripts: newProps.scripts.concat({
              _global: true,
              target: null,
              fn: 'function() { doLargeHeaderAnimations(); }'
            })
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.currentRefresh == this.state.refreshCounter && this.state.pendingScripts && this.state.pendingScripts.length) {
        var scripts = this.state.pendingScripts;
        var pendingScripts = scripts.filter(function (script) {
          if (script._global) {
            var f = Function('return ' + script.fn).call();
            f();
            return false;
          }

          var n = document.querySelector('#' + script.target);

          if (n) {
            runInlineScript(script.target, Function('return ' + script.fn).call());
            return false;
          }

          return true;
        });
        this.setState({
          pendingScripts: pendingScripts
        }); // doLargeHeaderAnimations();
      }

      if (this.state.currentRefresh != this.state.refreshCounter) {
        this.setState(function (_ref2) {
          var refreshCounter = _ref2.refreshCounter;
          return {
            currentRefresh: refreshCounter
          };
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        pendingScripts: this.props.scripts.concat({
          _global: true,
          target: null,
          fn: 'function() { doLargeHeaderAnimations(); }'
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "page-content-container",
        dangerouslySetInnerHTML: {
          __html: this.props.content + '<!-- ' + this.state.refreshCounter + ' -->'
        }
      });
    }
  }]);
  return PageContentContainer;
}(_react.Component);

exports.PageContentContainer = PageContentContainer;
var SiteLayout = (_class = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(SiteLayout, _Component2);

  var _super2 = _createSuper(SiteLayout);

  function SiteLayout() {
    var _this2;

    babelHelpers.classCallCheck(this, SiteLayout);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      top: 0,
      runScripts: false,
      hasPrevious: false
    };
    return _this2;
  }

  babelHelpers.createClass(SiteLayout, [{
    key: "gotRoot",
    value: function gotRoot(node) {
      this.rootNode = node; //	if (node) {
      //		node.addEventListener('click', this.nodeClicked);
      //	}
    }
  }, {
    key: "hideSideNav",
    value: function hideSideNav() {
      var x = $(document.documentElement).removeClass('nav-open');

      if (/iP(hone|ad)/.test(navigator.userAgent)) {
        this.iPhoneNav(false);
      }
    }
  }, {
    key: "navigate",
    value: function navigate(href) {
      var _this3 = this;

      var preserveScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var then = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      if (/^http(s):\/\//.test(href)) {
        if (href.substring(0, document.querySelector('base').href.length) == document.querySelector('base').href) {
          history.pushState({
            previousPage: location.href
          }, "", href);
          (0, _userProfile.userProfileUpdated)().then(function () {
            var P;
            if (!_this3.state.iPhoneNavOpen) P = _promisePolyfill.default.resolve(true);else P = _this3._iPhoneClosedNav();
            P.then(function () {
              _this3.setState({
                hasPrevious: true
              });

              $(document.documentElement).removeClass('nav-open');

              if (!preserveScrollPosition) {
                var st = (document.scrollingElement || document.documentElement).scrollTop;
                var A = new _animationHelper.default(300, 'ease-out', function (percent) {
                  (document.scrollingElement || document.documentElement).scrollTop = st * (1 - percent);
                });
                A.start();
                if (then) then();
              }
            });
          });
          return true;
        }
      }

      return false;
    }
  }, {
    key: "maybeGoBack",
    value: function maybeGoBack(base) {
      var _this4 = this;

      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : base;
      return new _promisePolyfill.default(function (resolve) {
        var target = document.createElement('a');
        target.href = base;

        if (history.state && history.state.previousPage.startsWith(target.href)) {
          var f = function f() {
            window.removeEventListener('popstate', f);
            requestAnimationFrame(function () {
              (0, _userProfile.getUserProfile)().then(function (done) {
                resolve(true);
              });
            });
          };

          window.addEventListener('popstate', f);
          history.back();
        } else {
          target.href = url || base;

          _this4.navigate(target.href, false, function () {
            resolve(true);
          });
        }
      });
    }
  }, {
    key: "nodeClicked",
    value: function nodeClicked(event) {
      if (event.defaultPrevented) return;
      var target = event.target;

      while (target && target.matches) {
        if (target.matches('a[href]')) {
          if (this.navigate(target.href, target.dataset.preserveScrollPosition == 'true')) {
            event.preventDefault();
            return;
          }
        }

        target = target.parentNode;
      }
    }
  }, {
    key: "gotSideNav",
    value: function gotSideNav(el) {
      this.sideNav = el;
    }
  }, {
    key: "gotMainContent",
    value: function gotMainContent(node) {
      this.mainContent = node;
    }
  }, {
    key: "iPhoneNav",
    value: function iPhoneNav(opened) {
      if (opened) {
        this._scrollTopPosition = $(document).scrollTop();
        setTimeout(this._iPhoneOpenedNav, 300);
      } else {
        this._iPhoneClosedNav();
      }
    }
  }, {
    key: "_iPhoneOpenedNav",
    value: function _iPhoneOpenedNav() {
      Object.assign(this.mainContent.style, {
        height: '100vh',
        overflow: 'hidden',
        width: '100vw',
        webkitOverflowScrolling: 'auto'
      });
      $(document).scrollTop(0);
      this.sideNav.style.top = '0px';
      this.setState({
        top: 0,
        iPhoneNavOpen: true
      });
    }
  }, {
    key: "_iPhoneClosedNav",
    value: function _iPhoneClosedNav(reset) {
      var _this5 = this;

      return new _promisePolyfill.default(function (resolve) {
        if (reset) {
          _this5._scrollTopPosition = 0;
        }

        $(document).scrollTop(_this5._scrollTopPosition);
        _this5.sideNav.style.top = _this5._scrollTopPosition + 'px';
        Object.assign(_this5.mainContent.style, {
          height: '',
          overflow: '',
          width: '',
          webkitOverflowScrolling: ''
        });

        _this5.setState({
          top: _this5._scrollTopPosition,
          iPhoneNavOpen: false
        }, function () {
          return resolve(true);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          scripts = _this$props.scripts,
          type = _this$props.type,
          props = babelHelpers.objectWithoutProperties(_this$props, _excluded);
      var ContentContainer = type ? require(type).default : PageContentContainer;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.gotRoot,
        className: "page-wrapper",
        id: "content",
        onClick: this.nodeClicked
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "siteNavigationContainer",
        className: "side-navigation overlay",
        style: {
          top: "".concat(this.state.top, "px")
        },
        ref: this.gotSideNav
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "close-btn",
        src: "/admin/platform/plugins/".concat(_corePlugin.default, "/resources/images/close-white.png"),
        onClick: this.handleNavigation
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "side-nav-main",
        id: "side-nav-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_SidebarNavigation.default, props))), /*#__PURE__*/_react.default.createElement("div", {
        className: "page-main",
        id: "mainContentContainer",
        ref: this.gotMainContent
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "main-overlay",
        onClick: this.handleNavigation
      }), /*#__PURE__*/_react.default.createElement("div", {
        id: "nav-container"
      }, /*#__PURE__*/_react.default.createElement(_SiteNavigation.default, _extends({}, props, {
        hasPrevious: this.state.hasPrevious,
        menuToggle: this.handleNavigation,
        top: this.state.top
      }))), /*#__PURE__*/_react.default.createElement(ContentContainer, {
        content: content,
        scripts: scripts
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "footer-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "footer-copyright-container",
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement(_FooterNavigation.default, props)))));
    }
  }, {
    key: "handleNavigation",
    value: function handleNavigation() {
      var _this6 = this;

      this.setState({
        top: $(document).scrollTop()
      }, function () {
        var x = $(document.documentElement).toggleClass('nav-open');

        if (/iP(hone|ad)/.test(navigator.userAgent)) {
          _this6.iPhoneNav(x.is('.nav-open'));
        }
      });
    }
  }, {
    key: "preventMove",
    value: function preventMove(e) {
      if (_classList.default.has(document.documentElement, 'nav-open')) {
        e.preventDefault();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      SiteLayout.current = this; // const { children, ...props } = this.props;

      (0, _setup.setupProfile)();
      (0, _userProfile.setInitialSiteProps)(this.props); // var scripts = this.props.scripts;
      // scripts.forEach(script => {
      // 	runInlineScript(script.target, Function('return ' + script.fn).call());
      // })

      window.addEventListener('popstate', this._doUserProfileUpdated);
      window.addEventListener('resize', this.doWidth, {
        passive: true
      });
      if (/iPhone/.test(navigator.userAgent) || /iPad/.test(navigator.userAgent)) document.body.classList.add('iphone');
      this.doWidth();
    }
  }, {
    key: "_doUserProfileUpdated",
    value: function _doUserProfileUpdated() {
      (0, _userProfile.userProfileUpdated)();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('popstate', this._doUserProfileUpdated);
      window.removeEventListener('resize', this.doWidth, {
        passive: true
      });
      SiteLayout.current = null;
    }
  }, {
    key: "doWidth",
    value: function doWidth(event) {
      var trim = function trim(s) {
        return s.replace(/^\s*/, '').replace(/\s*$/, '');
      };

      var r = window.getComputedStyle(document.body);
      var desktopTargetWidth = trim(r.getPropertyValue('--scalable-desktop-target-width'));
      var desktopTargetHeight = trim(r.getPropertyValue('--scalable-desktop-target-height'));
      var mobileTarget = trim(r.getPropertyValue('--scalable-mobile-target-width'));
      var fontSize = trim(r.getPropertyValue('--scalable-base-font-size'));
      var isMobile = trim(r.getPropertyValue('--scalable-mobile'));
      var ww = $(window).width(),
          wh = $(window).height();

      switch (isMobile) {
        case 'false':
          var baseR = desktopTargetWidth / desktopTargetHeight;
          var winR = ww / wh;
          document.body.style.setProperty('--scalable-base-ratio', baseR);
          document.body.style.setProperty('--scalable-target-ratio', winR);
          var cellHeight,
              cellWidth,
              columnCount,
              rowCount,
              unit,
              baseCellHeight = desktopTargetHeight / 100;

          if (winR > baseR) {
            rowCount = 100;
            columnCount = 100 * winR / baseR;
          } else {
            rowCount = 100 * baseR / winR;
            columnCount = 100;
          }

          cellHeight = wh / rowCount;
          cellWidth = ww / columnCount;
          unit = fontSize * (cellHeight / baseCellHeight);
          var x = {
            '--scalable-target-cell-height': cellHeight,
            '--scalable-target-cell-width': cellWidth,
            '--scalable-target-cell-columns': columnCount,
            '--scalable-target-cell-rows': rowCount,
            '--scalable-target-font-ratio': cellHeight / baseCellHeight,
            '--scalable-target-font-size': unit,
            '--scalable-unit': "".concat(unit, "px")
          };
          Object.keys(x).forEach(function (k) {
            return document.body.style.setProperty(k, x[k]);
          });
          break;

        case 'true':
          document.body.style.removeProperty('--scalable-unit');
          break;
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      var _this7 = this;

      if (Object.keys(nextProps).filter(function (p) {
        return _this7.props[p] != nextProps[p];
      }).length) {
        var sp = [];
        this.rootNode.querySelectorAll('.block.pill-nav > .inner-content').forEach(function (node) {
          if (window.getComputedStyle(node).getPropertyValue('--is-tab-nav')) {
            sp.push({
              scrollLeft: node.scrollLeft
            });
          }
        });
        this.scrollPositionList = sp;
      }

      document.title = nextProps.pageTitle;
      document.body.className = nextProps.bodyClass.concat('loaded').join(' ');

      if (/Trident/.test(navigator.userAgent)) {
        document.body.className += ' trident';
      }

      if (/iP(hone|ad)/.test(navigator.userAgent)) document.body.className += ' iphone';
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this8 = this;

      if (!$(document.documentElement).is('.nav-open') && this.state.iPhoneNavOpen) {
        this._iPhoneClosedNav(true);
      } // doLargeHeaderAnimations();


      document.title = this.props.pageTitle;
      document.body.className = this.props.bodyClass.concat('loaded').join(' ');

      if (/Trident/.test(navigator.userAgent)) {
        document.body.className += ' trident';
      }

      if (/iP(hone|ad)/.test(navigator.userAgent)) document.body.className += ' iphone';
      var metaKeywords = document.querySelector('meta[name=Keywords]');
      var metaDescription = document.querySelector('meta[name=Description]');

      if (this.props.metaKeywords) {
        if (!metaKeywords) {
          metaKeywords = document.createElement('meta');
          metaKeywords.setAttribute('name', 'Keywords');
          document.head.appendChild(metaKeywords);
        }

        metaKeywords.setAttribute('content', this.props.metaKeywords);
      } else {
        if (metaKeywords) {
          metaKeywords.parentNode.removeChild(metaKeywords);
        }
      }

      if (this.props.metaDescription) {
        if (!metaDescription) {
          metaDescription = document.createElement('meta');
          metaDescription.setAttribute('name', 'Description');
          document.head.appendChild(metaDescription);
        }

        metaDescription.setAttribute('content', this.props.metaDescription);
      } else {
        if (metaDescription) {
          metaDescription.parentNode.removeChild(metaDescription);
        }
      }

      if (this.scrollPositionList) {
        var sps = this.scrollPositionList; // this.scrollPositionList = null;

        var i = 0;
        this.rootNode.querySelectorAll('.block.pill-nav > .inner-content').forEach(function (node) {
          if (window.getComputedStyle(node).getPropertyValue('--is-tab-nav') && sps.length) {
            node.scrollLeft = sps[i++].scrollLeft;
          }
        });

        if (Object.keys(prevProps).filter(function (p) {
          return _this8.props[p] != prevProps[p];
        }).length == 0) {
          this.scrollPositionList = 0;
        }
      }

      if (!!prevProps.userProfile != !!this.props.userProfile || prevProps.userProfile && this.props.userProfile && prevProps.userProfile.id != this.props.userProfile.id) document.body.dataset.topPosition = 0;
    }
  }], [{
    key: "show",
    value: function show(props) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(this, props), document.querySelector('#outerContainer'));
    }
  }]);
  return SiteLayout;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotRoot"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "hideSideNav", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "hideSideNav"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "navigate", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "navigate"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "maybeGoBack", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "maybeGoBack"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "nodeClicked", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "nodeClicked"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotSideNav", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotSideNav"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotMainContent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotMainContent"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_iPhoneOpenedNav", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_iPhoneOpenedNav"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_iPhoneClosedNav", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_iPhoneClosedNav"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleNavigation", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleNavigation"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "preventMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "preventMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_doUserProfileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_doUserProfileUpdated"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doWidth", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doWidth"), _class.prototype)), _class);
exports.default = SiteLayout;